import { Acl$ } from './acl$';
import { Attachment$ } from './attachment$';
import { Auth } from '@angular/fire/auth';

import { Ace$ } from './ace$';
import { Counter$ } from './counter$';
// import { Autotag$ } from './autotag$';
import { BehaviorSubject, interval, Subject } from 'rxjs';
import { BinaryTree$ } from './binary-tree$';
import { Bulk$ } from './bulk$';
import { Citation$ } from './citation$';
import { Comment$ } from './comment$';
import { Config$ } from './config$';
import { Databin$ } from './databin$';
import { Dataset$ } from './dataset$';
import { CITATION_STYLE_ENTRY, Display$ } from './display$';
import { Eduid$ } from './eduid$';
import { Export$ } from './export$';
import { ExternalWeb$ } from './external-web$';
import { Filesystem$ } from './filesystem$';
import { Field$ } from './field$';
import { Filter$ } from './filter$';
import { Firebase$ } from './firebase$';
import { Gui$ } from './gui$';
import { Help$ } from './help$';
import { Highlight$ } from './highlight$';
import { Injectable } from '@angular/core';
import { Keyboard$ } from './keyboard$';
import { Keyword$ } from './keyword$';
import { Location } from '@angular/common';
import { Logs$ } from './logs$';
import { Manifest$ } from './manifest$';
import { Online$ } from './online$';
import { Overlap$ } from './overlap$';
import { Person } from './person';
import { Pin$ } from './pin$';
import { Project$ } from './project$';
import { Random$ } from './random$';
import { Report$ } from './report$';
import { ResultList$ } from './result-list$';
import { Selection$ } from './selection$';
import { Script$ } from './script$';
import { Search$ } from './search$';
import { SearchArchive$ } from './search-archive$';
import { Stage$ } from './stage$';
import { Stats$ } from './stats$';
import { System$ } from './system$';
import { Table$ } from './table$';
import { TAG } from './section';
import { Template$ } from './template$';
import { Temporal } from '@js-temporal/polyfill';
import { Transformer$ } from './transformer$';
import { Upload$ } from './upload$';
import { User$ } from './user$';
import { AutoUser$ } from './auto-user$';
import { Utils$ } from './utils$';
import { View$ } from './view$';
import { Worker$ } from './worker$';
import { ScriptInput } from './script-input';
import { Batch$ } from './batch$';
import { License$ } from './license$';
import { Meta, Title } from '@angular/platform-browser';

declare var Cite: any;

export const MANIFEST_STORE_DELAY = 1000;
@Injectable({
    providedIn: 'root',
})
export class CoordinatorService {
    citeEngine: any;
    private _appId = 'f5b29ea5-32c3-4e98-96be-e91fdd960ccb';
    private _formatId = '21401-001';

    private _appChannel = new BroadcastChannel(this._appId);

    private _isLicenseManager = false;

    private _isAI = false;

    anyMessage$ = new Subject<any>();

    // private _nsDO = "https://faas-fra1-afec6ce7.doserverless.co/api/v1/web/fn-e7ca6382-6294-4fc0-a435-fd626485ac35/"

    // storeTick$ = interval(1000)

    instanceId: string;

    private _isOnline = true;

    isLocked$ = new BehaviorSubject(false);

    pluginMap = new Map<string, any>();

    memowlLink$ = new Subject();

    varProviderLs: any = [];

    // templateTypes = EDIT_TYPES_LS
    developmentSet = new Set<string>();

    isInitPeriod = true;
    serviceEmail = 'support@memowl.com';

    // user: UserOld
    // user$ = new Subject<UserOld>()

    private _sectionOrderLs: TAG[] = ['views', 'ratings', 'tags', 'keywords'];

    template$ = new Template$(this);
    acl$ = new Acl$(this);
    attachment$ = new Attachment$(this);
    batch$ = new Batch$(this);
    bulk$ = new Bulk$(this);
    binaryTree$ = new BinaryTree$(this);
    citation$ = new Citation$(this);
    comment$ = new Comment$(this);
    databin$ = new Databin$(this);
    dataset$ = new Dataset$(this);
    eduid$ = new Eduid$(this);
    export$ = new Export$(this);
    externalWeb$ = new ExternalWeb$(this);
    filesystem$ = new Filesystem$(this);
    firebase$ = new Firebase$(this);
    gui$ = new Gui$(this);
    highlight$ = new Highlight$(this);
    keyboard$ = new Keyboard$(this);
    manifest$ = new Manifest$(this);
    overlap$ = new Overlap$(this);
    online$ = new Online$(this);
    pin$ = new Pin$(this);
    project$ = new Project$(this);
    random$ = new Random$(this);
    upload$ = new Upload$(this);
    report$ = new Report$(this);
    stats$ = new Stats$(this);
    system$ = new System$(this);
    resultList$ = new ResultList$(this);
    keyword$ = new Keyword$(this);
    stage$ = new Stage$(this);
    search$ = new Search$(this);
    searchArchive$ = new SearchArchive$(this);
    field$ = new Field$(this);
    filter$ = new Filter$(this);
    selection$ = new Selection$(this);
    table$ = new Table$(this);
    display$ = new Display$(this);
    transformer$ = new Transformer$(this);
    user$ = new User$(this);
    autouser$ = new AutoUser$(this);
    view$ = new View$(this);
    license$ = new License$(this);

    utils$ = new Utils$(this);
    logs$ = new Logs$(this);
    script$ = new Script$(this);
    ace$ = new Ace$(this);
    help$ = new Help$(this);
    worker$ = new Worker$(this);
    config$ = new Config$(this);
    counter$ = new Counter$(this);

    saveDatasetViewRequest$ = new Subject();

    reset$ = new Subject();

    isTopFrame = window === top;

    personMap = new Map<string, Person>();

    constructor(
        public auth: Auth,
        public loc: Location,
        private _browserTitle: Title,
        private _browserMeta: Meta,
    ) {
        window.addEventListener('beforeunload', (event) => {
            if (this.hasInProgressActions) {
                this.upload$.beforeUnload();
                this.display$.dialog$.next({ action: 'in-progress' });
                event.preventDefault();
            } else {
                this._appChannel.close();
            }
        });

        window.addEventListener('references', (x: any) => {
            const params = x.detail;
            const xitem = this.dataset$.main.get(params.xitemId);
            if (!xitem) return;
            const batchId = params.batchId;
            const batch = this.batch$.get(batchId);
            console.log(123, params, params.batchId);
            const payload = this.batch$.getTmpStore(batchId)?.get(params.v);

            const kind = params.key;
            this.display$.dialog$.next({ action: 'batch-references', payload, kind, xitem, batch });
        });

        window.addEventListener('xitem-value-change', (x: any) => {
            const data = x.detail;
            const xitm = this.dataset$.main.get(data.xitemId);
            if (!xitm) return;
            xitm.set(data.key, data.v);
            this.dataset$.main.markForManifestStore();
            this.display$.markForCheck();
        });

        window.addEventListener('online', () => this._onlineStatus(true));
        window.addEventListener('offline', () => this._onlineStatus(false));
        window.addEventListener('focus', () => {
            this.display$.markForCheck();
            this.display$.focus$.next();
        });

        window.addEventListener('message', (event) => {
            // Check the origin to ensure security
            if (event.origin !== location.origin) {
                return; // Ignore messages from unexpected sources
            }

            // Assuming your data is structured with a 'type' property
            if (event.data.type === 'scriptAction') {
                this.script$.run(event.data.action); // Caution: using eval() can be risky, be sure to fully trust the source
            }
        });

        this.search$.onStart();
        this.export$.onStart();
        this.highlight$.onStart();
        this.databin$.onStart();

        // this.stage$.onStart()
        // this.filterBin$.onStart()
        this.resultList$.onStart();
        // this.filterTree$.onStart()
        this.online$.onStart();
        // this.autotag$.onStart();
        this.script$.onStart();
        this.utils$.onStart();
        this.batch$.onStart();

        this._appChannel.onmessage = async (e) => {
            const data = e.data;
            switch (data.action) {
                case 'loginTkn':
                    const tkn = data.tkn;
                    this.firebase$.customTokenLogin(tkn);
                    break;
                case 'open':
                    if (this.project$.currentId === data.id) await this.project$.current;
                    this.display$.markForCheck();
                    break;
            }
        };

        this.manifest$.onStart();
        this.externalWeb$.onStart();
        // this.overlap$.onStart();
        // this.filesystem$.onStart()
        this.dataset$.onStart();
        this.project$.onStart();
        this.firebase$.onStart();
        this.instanceId = this.uniqueId();

        this.initCiteEngine({ isStart: true });
    }

    set browserTitle(txt: string) {
        const suffix = this.display$.targetSite('@memowl') ? 'Memowl' : 'RefereNTKa';
        this._browserTitle.setTitle(`${txt} [${suffix}]`);
    }

    async initCiteEngine({ isStart }: { isStart?: boolean } = {}) {
        console.log('CITE-ENGINE-INIT');
        if (typeof Cite === 'undefined' || typeof Cite.plugins === 'undefined') {
            throw new Error('Citation.js is not loaded. Please check your CDN setup.');
        }

        this.citeEngine = new Cite();

        console.log(
            'Loaded Cite Engine and Plugins: ',
            this.citeEngine,
            Cite.plugins.config.list(),
        );

        if (isStart) {
            const templLs: CITATION_STYLE_ENTRY[] = [
                {
                    id: 'acs',
                    title: 'American Chemical Society',
                    abbrev: 'ACS',
                    fn: 'american-chemical-society.csl',
                },
                {
                    id: 'apa',
                    title: 'American Psychological Association 7th edition',
                    abbrev: 'APA',
                    fn: 'apa.csl',
                },
                { id: 'nature', title: 'Nature', fn: 'nature.csl' },
                // { id: 'chicago', fn: 'chicago-author-date.csl' },
                // { id: 'ieee', fn: 'ieee.csl' },
                // { id: 'vancouver', fn: 'vancouver.csl' },
                // { id: 'jstor', fn: 'jstor.csl' },
            ];

            templLs.forEach((x) => {
                fetch(`assets/CSL/${x.fn}`)
                    .then((resp) => resp.text())
                    .then((template) => this.addStyle(Object.assign(x, { template })));
            });
        }
    }

    addStyle({ id, title, abbrev, template }: CITATION_STYLE_ENTRY) {
        const config = Cite.plugins.config.get('@csl');
        config.templates.add(id, template);
        this.display$.citationStyleMap.set(id, { id, title, abbrev });
        this.display$.markForCheck();
    }

    initCiteEngineWithData(data: string) {
        return new Cite(data);
    }

    quit() {
        if (!this.hasInProgressActions) location.reload();
    }

    appChannelPost(params: any) {
        this._appChannel.postMessage(params);
    }

    public get sectionOrderLs(): TAG[] {
        return this._sectionOrderLs;
    }

    private _onlineStatus(isOnline: boolean) {
        if (isOnline) {
            this._isOnline = true;
            this.display$.openSnackBar(undefined, { message: 'You are back online!' }, 3);
        } else {
            this._isOnline = false;
            this.display$.openSnackBar(undefined, { message: 'Offline' }, 1000);
        }
    }

    async updateAuthClaims() {
        const cu = this.auth.currentUser!;
        const resp = await cu.getIdToken(true);
        const tkn = await cu.getIdTokenResult();
    }

    get isOnline() {
        return this._isOnline;
    }

    // get isLocal() {
    //     return location.hostname.includes('.ng');
    // }

    // get isDevelopment() {
    //     return this.isLocal || location.hostname.includes('11e99');
    // }

    // get isMemowl() {
    //     return !this.isReferentka;
    // }

    // get isReferentka() {
    //     return (
    //         location.hostname.endsWith('referentka.app') ||
    //         location.hostname.endsWith('referentka.web.app')
    //     );
    // }

    // get isReferentkaProd() {
    //     return location.hostname === 'referentka.app';
    // }

    // get isMemowlProd() {
    //     return location.hostname === 'memowl.app';
    // }

    // get isReferentkaBeta() {
    //     return location.hostname === 'beta.referentka.app';
    // }

    // get isMemowlBeta() {
    //     return location.hostname === 'beta.memowl.app';
    // }

    // get isBeta() {
    //     return this.isReferentkaBeta || this.isMemowlBeta;
    // }

    get canUseDevTools() {
        return this.display$.targetSite('@beta') && this.user$.current?.isAdmin;
        // return (this.isDevelopment || this.isBeta) && this.user$.current?.isAdmin;
    }

    // createOverlapMatrix() {
    //   return new OverlapMatrix(this)
    // }

    saveDict(id: string, type: string) {
        return {
            appId: this._appId,
            formatId: this._formatId,
            id: id,
            type: type,
        };
    }

    refreshItemDisplay() {
        this.display$.tickRefmanagerDisplay$.next({
            refresh: true,
        });
    }

    checkDoi(txt: string) {
        return txt && txt.startsWith('10.') && txt.indexOf('/') > 6;
    }

    help(helpId: string) {
        this.gui$.openDialog$.next({
            section: 'display',
            action: 'open',
            type: 'help',
            data: { helpId: helpId },
        });
    }

    icon(tag: string) {
        return this.display$.icon(tag);
    }

    text(tag: string) {
        return this.display$.text(tag);
    }

    testArrayEqual(a: any[], b: any) {
        if (!a && !b) return true;
        if (!a || !b) return false;
        if (a.length != b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i] != b[i]) {
                return false;
            }
        }
        return true;
    }

    gestureDirection(start: Touch, end: Touch) {
        const cutoff = 75;
        if (
            Math.abs(end.clientX - start.clientX) + Math.abs(end.clientY - start.clientY) <
            cutoff
        ) {
            return undefined;
        }

        if (end.clientX - start.clientX == 0) {
            if (end.clientY > start.clientY) {
                return 'S';
            } else {
                return 'N';
            }
        }
        const slope = (end.clientY - start.clientY) / (end.clientX - start.clientX);
        if (Math.abs(slope) < 0.3) {
            if (end.clientX - start.clientX < 0) {
                return 'W';
            } else {
                return 'E';
            }
        } else if (end.clientY > start.clientY) {
            return 'S';
        } else {
            return 'N';
        }
    }

    nowStamp() {
        return Temporal.Now.instant().toString();
    }

    uniqueId(prefix?: string) {
        prefix = prefix || '';
        let suffix;
        try {
            suffix = this.utils$.generateUUID();
        } catch (e) {
            const a = Temporal.Now.instant().epochNanoseconds.toString(36).slice(-8);
            const b = Math.floor(Math.random() * 1000000000).toString(36);
            suffix = `${a}${b}`;
        }

        return `${prefix}${prefix ? '-' : ''}${suffix}`;
    }

    paddedNumber(nmb: number, len = 2): string {
        return nmb.toString().padStart(len, '0');
    }

    get datetimeForTitle() {
        const dtp = Temporal.Now.plainDateTimeISO();
        const months = this.paddedNumber(dtp.month);
        const days = this.paddedNumber(dtp.day);
        const hours = this.paddedNumber(dtp.hour);
        const minutes = this.paddedNumber(dtp.minute);
        const y = `${dtp.year}-${months}-${days}`;
        const h = `${hours}-${minutes}`;
        return `${y}_${h}`;
    }

    dateString(dt: Temporal.Instant, withTime = false) {
        try {
            const zdt = dt.toZonedDateTime({ timeZone: 'UTC', calendar: 'iso8601' });
            const months = this.paddedNumber(zdt.month);
            const days = this.paddedNumber(zdt.day);
            return `${zdt.year}/${months}/${days}`;
        } catch (e) {
            return `${dt}`;
        }
    }

    timeString(dt: Temporal.Instant) {
        try {
            const zdt = dt.toZonedDateTimeISO(Intl.DateTimeFormat().resolvedOptions().timeZone);
            const hours = this.paddedNumber(zdt.hour);
            const minutes = this.paddedNumber(zdt.minute);
            const secs = this.paddedNumber(zdt.second);
            return `${hours}:${minutes}:${secs}`;
        } catch (e) {
            return `${dt}`;
        }
    }

    dateTimeString(dt: Temporal.Instant) {
        return `${this.dateString(dt)} ${this.timeString(dt)}`;
    }

    escapeFilename(txt: string) {
        return txt.replace(/\s+/g, '_').replace(/\/+/g, '_');
    }

    // iriViaProxy(iri: string) {
    //   const proxy = "https://winter-snowflake-2d63.nicmila.workers.dev"
    //   const url = new URL(iri)

    //   const finalURL = new URL(proxy)
    //   finalURL.pathname = url.pathname
    //   const sp = new URLSearchParams()
    //   sp.append("U", url.host)
    //   sp.append("A", "localMemowl")
    //   finalURL.search = sp.toString()
    //   return finalURL.toString()
    // }

    // createAttachment(params?) {
    //   return new Attachment(this, params)
    // }

    home(top?: number) {
        top = top || 0;
        // console.log("TTT", top)
        window.scrollTo(0, top);
    }

    urlLinkTitle(txt: string) {
        const url = new URL(txt);
        return url.host;
    }

    importPersons(ls: any[]) {
        ls.forEach((x) => new Person(this, x));
    }

    getPerson(personId: string) {
        let p = this.personMap.get(personId);
        if (!p) {
            p = new Person(this, {
                id: personId,
                firstname: '',
                surname: 'Unknown',
            });
            this.personMap.set(p.id, p);
        }
        return p;
    }

    exportPersons() {
        const ls: any[] = [];
        this.personMap.forEach((p) => ls.push(p.export()));
        return ls;
    }

    openBlob(blob: Blob) {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.target = '_blank';
        a.click();
        a.remove();
        return;
    }

    saveFile(filename: string, payload: any, isRaw = true) {
        this.filesystem$.save({
            isRaw: isRaw,
            filename: filename,
            payload: payload,
        });
    }

    // login() {
    //   this.auths.loginWithPopup()
    // }

    // logout() {
    //   this.auths.logout()
    // }

    hash(x: string) {
        if (typeof x != 'string') x = JSON.stringify(x);
        return `${x.length}|${x.split('').reduce((a, b) => {
            a = (a << 5) - a + b.charCodeAt(0);
            return a & a;
        }, 0)}`;
    }

    shorten(txt: string, maxLen = 300) {
        if (!txt) return '';
        if (txt.length > maxLen) {
            txt = txt.slice(0, maxLen);
            txt = txt.slice(0, txt.lastIndexOf(' '));
            txt += ' …';
        }
        return txt;
    }

    reload(p: any = undefined) {
        if (p) {
            p.store();
            setTimeout(() => location.reload(), 500);
        } else {
            location.reload();
        }
    }

    map2json(mp: Map<string, any>, params?: any) {
        const dct = Object.fromEntries(mp);
        Object.keys(params).forEach((k) => {
            dct[k] = params[k];
        });
        Object.keys(dct).forEach((k) => {
            const v = dct[k];
            if (v === undefined) delete dct[k];
            if (v && v.toJSON) dct[k] = v.toJSON();
        });
        return dct;
    }

    // googlePatentLinkLs(patentNumber?: string) {
    //     if (!patentNumber) patentNumber = this.resultList$.activeItem?.get('patentNumber');
    //     if (!patentNumber) return [];
    //     const ls: [any, any][] = [];
    //     patentNumber.split(';').forEach((x) => {
    //         x = x.trim();
    //         const tag = x!.slice(0, 2);
    //         const pn = x!.slice(2).replaceAll('-', '');
    //         const n = parseInt(pn);
    //         const t1 = `${tag}${pn}`;
    //         const t2 = `${tag}${n}`;
    //         ls.push([
    //             {
    //                 title: t1,
    //                 href: `https://patents.google.com/?oq=${t1}`,
    //             },
    //             {
    //                 title: t2,
    //                 href: `https://patents.google.com/?oq=${t2}`,
    //             },
    //         ]);
    //     });
    //     return ls;
    // }

    get hasInProgressActions() {
        return this.upload$.isUploadInProgress || this.attachment$.hasActiveUploads;
    }

    openProjectOnStart(pilId: string) {
        this.project$.startPILid = pilId;
    }

    async openCoupon(coupon: string) {
        const resp = await this.firebase$.callFunction('couponRedeem', { coupon });
        if (!resp || resp === 'ERROR') {
            alert('Coupon Claim Failed');
            return;
        }
        const data = (resp as any)?.data;
        const lk = data?.lk;
        console.log('LK', data, lk);
        if (data.isSuccess) {
            alert('Coupon FFFF');
        } else {
            alert('Coupon failure ' + data.message);
        }
    }

    async serverPayload(code: string) {
        const resp = await this.firebase$.callFunction('serverPayload', { code });
        if (!resp || resp === 'ERROR') return;
        const data = (resp as any)?.data;
        switch (data?.action) {
            case 'stage':
                switch (data.target) {
                    case 'license':
                        this.isLicenseManager = true;
                        this.display$.closeDialog();
                        break;
                }
                break;
        }
        return data;
    }

    async providerCode(code: string) {
        const resp = await this.firebase$.callFunction('providerCode', { code });
        if (!resp || resp === 'ERROR') return;
        const data = (resp as any)?.data;
        console.log('PROVIDER CODE', data);
    }

    async loadAPI(apiID: string) {
        const blob = await this.firebase$.storage.downloadFile2(`api/tmp/${apiID}`);
        const txt = await blob?.text();

        this.manifest$.post('api', {
            data: txt,
        });
    }
    async loadPublicFile(pid: string) {
        const params: any = await this.firebase$.firestore.getObject('public', pid);

        console.log('LOAD PUBLIC FILE', pid, params);
        try {
            const inst = Temporal.Instant.from(params.expiration as string);
            if (params.remotePath && Temporal.Instant.compare(inst, Temporal.Now.instant()) > 0) {
                const blob = await this.firebase$.storage.downloadFile2(params.remotePath);
                if (!blob) return;
                const inp = new ScriptInput(this);
                await inp.process(blob);
                inp.asNew();
            } else throw new Error('Expired');
        } catch (e) {
            console.log('LOAD PUBLIC FILE ERROR', e);
            alert('LINK EXPIRED');
        }

        return false;
    }

    get isViewer() {
        return !!this.project$.current?.isViewMode;
    }

    private _clearSectType() {
        if (this._isLicenseManager) this._isLicenseManager = false;
    }

    get isManager() {
        if (location.pathname.startsWith('/subscription')) return false;
        return !this.display$.isExternalLogin && !this.isLicenseManager;
    }

    set isManager(value) {
        this._clearSectType();
        this.display$.markForCheck();
    }

    afterRoute(params: any) {
        console.log('AFTER ROUTE', params);
    }

    public get isLicenseManager() {
        if (location.pathname.startsWith('/subscription')) {
            this._isLicenseManager = true;
            return true;
        }
        return this._isLicenseManager;
    }
    public set isLicenseManager(value) {
        if (this._isLicenseManager === value) return;
        this._clearSectType();
        this._isLicenseManager = value;
        this.display$.markForCheck();
    }
}
